export default {
    allChallenge: [],
    showChallenge: {},
    challengeDeleteId: '',
    pagination: {},
    searchQuery: "",
}

